import React, { useContext } from 'react';
import { theme } from '../Theming/Theming';
import { styled } from 'linaria/react';
import SiteContentContext from '../SiteContent/SiteContentContext';

const ProductUspBoxWrapper = styled('div')`
  width: 100%;
  margin-top: 1rem;
  ${theme.below.lg} {
    padding-bottom: 0;
  }
  .title {
    font-weight: ${theme.weights.bold};
    margin-bottom: 1rem;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      line-height: 2;
      font-size: 0.9rem;
      text-decoration: underline;
      img {
        margin-right: 5px;
        max-width: 16px;
      }
      span {
      }
    }
  }
`;

const ProductUspBox = () => {
  const { productPageUsp } = useContext(SiteContentContext);
  return <ProductUspBoxWrapper>{productPageUsp}</ProductUspBoxWrapper>;
};

export default ProductUspBox;
